import React from "react"
import { Space, Typography } from "antd"

import { Value } from "@components/Text"
import {
  CUSTODIAN_REVIEWED_SDIRA,
  CHECKBOOK_CONTROLLED_SDIRA
} from "@api/services/investments/shapes/SdiraTypeEnum"

import renderAdditional from "./renderAdditional"

const LABEL_TYPE = "SDIRA Type"
const LABEL_NAME = "Full Legal SDIRA Account Name"
const LABEL_CUSTODIAN = "Custodian"
const LABEL_ENTITY_EIN = "Entity EIN"
const LABEL_INVESTMENTS = "Investments"
const LABEL_ENTITY_NAME = "Entity’s Full Legal Name"

const TYPE_LABELS_MAP = {
  [CUSTODIAN_REVIEWED_SDIRA]: "Custodian-reviewed SDIRA",
  [CHECKBOOK_CONTROLLED_SDIRA]: "Checkbook-controlled SDIRA"
}


const renderProfileSdira = (profileSdira, formattedInvestments, investor, additionalExtra) => {
  const {
    sdiraType,
    entityName,
    hasEinNumber,
    einNumber,
    accountName,
    custodianName,
    custodianAddress = {},
    custodianEinNumber
  } = profileSdira

  const items = []

  const isCheckbook = sdiraType === CHECKBOOK_CONTROLLED_SDIRA
  const isOtherCustodian = !custodianAddress.addressRegion

  items.push({
    span: 2,
    label: LABEL_TYPE,
    value: TYPE_LABELS_MAP[sdiraType],
  })

  if (isCheckbook) {
    items.push({
      span: 2,
      label: LABEL_ENTITY_NAME,
      value: entityName,
    })

    if (hasEinNumber) {
      items.push({
        span: 2,
        label: LABEL_ENTITY_EIN,
        value: <Value value={einNumber} isEin />
      })
    }
  }

  items.push({
    span: 2,
    label: LABEL_NAME,
    value: accountName,
  })

  if (formattedInvestments) {
    items.push({
      span: 2,
      label: LABEL_INVESTMENTS,
      value: formattedInvestments
    })
  }

  items.push({
    span: 2,
    label: LABEL_CUSTODIAN,
    value: isOtherCustodian
      ? "Other"
      : (
        <Space direction="vertical" size={0}>
          <Typography.Text>
            <Typography.Text strong>
              {custodianName}
            </Typography.Text>
            {" "}
            <Typography.Text type="secondary">
              (<Value value={custodianEinNumber} isEin />)
            </Typography.Text>
          </Typography.Text>

          <Value value={custodianAddress} />
        </Space>
      )
  })

  items.push(renderAdditional(profileSdira, additionalExtra))

  return items
}

export default renderProfileSdira
